// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"21265111","160":"22934d57","208":"d0d2cc33","293":"72b57819","453":"bfd25a69","516":"76839de3","519":"888c4630","917":"1881ea15","946":"2cf59975"}[chunkId] + ".chunk.js";
};